import { stringTemplate, TemplateData } from '@oy/uidesktop';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers/rootReducer';
import { SupportedLocale, translate } from 'src/utilities/translator';

const useTranslate = () => {
  const lang = useSelector(
    (state: RootState): SupportedLocale => state.main.lang,
  );

  const isLangEn = lang === 'en';

  const isLangId = lang === 'id';

  const getTranslation = (path: string, template?: TemplateData) =>
    template
      ? stringTemplate({ str: translate(lang, path), template })
      : translate(lang, path);

  return { lang, getTranslation, isLangEn, isLangId };
};

export default useTranslate;
